import * as Yup from "yup";

const reviewValidationSchema = Yup.object().shape({
    review: Yup.string().required("Required").min(10, "Review must be at least 10 characters long")
    .test('no-spaces', 'Review cannot be only spaces', (value) => {
        return value && value.trim().length > 0;
      })
})

export default reviewValidationSchema;